import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;

let initialized = false;

export const initPostHog = () => {
  console.log('[PostHog] init called, KEY:', POSTHOG_KEY ? 'present' : 'MISSING', 'HOST:', POSTHOG_HOST || 'MISSING');
  if (!POSTHOG_KEY || !POSTHOG_HOST || initialized) return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    disable_session_recording: true,
  });
  initialized = true;
  console.log('[PostHog] initialized successfully');
};

export const identifyUser = (user) => {
  if (!initialized || !user) return;
  posthog.identify(user.azure_id || user.id?.toString(), {
    email: user.email,
    name: user.name,
    role: user.role,
  });
};

export const trackEvent = (event, properties = {}) => {
  if (!initialized) return;
  posthog.capture(event, properties);
};

export const resetPostHog = () => {
  if (!initialized) return;
  posthog.reset();
};

export { posthog };
